/**
 * Public drop-in receipts prefer the live school name. Ticket fields are
 * snapshots from purchase time and stay as fallbacks until the client loads.
 */
export const getDropinReceiptSchoolName = (
  liveSchoolName: string | undefined,
  ticketClientName: string | undefined,
  ticketSchoolName: string | undefined
): string | undefined => liveSchoolName || ticketClientName || ticketSchoolName
